import React from 'react'
import { styled } from 'linaria/react'
import { generateUniqueId } from '../../Core/Util/Helpers'
import ArrowBtn from '../../../svg/ArrowBtn.svg'
import { cx } from 'linaria'

const Container = styled.div`
   /* background-color: white; */
`
const AccordionPanel = styled.div`
   .accordion-header {
      opacity: ${props => (props.isEmpty ? 0.5 : 1)};
      pointer-events: ${props => (props.isEmpty ? 'none' : 'auto')};
   }

   .accordion-item {
      border-radius: 0;
      border-top: 0;
      border-left: 0;
      border-right: 0;
      border-width: 2px;
      font-family: var(--font-grotesk-regular);
   }

   .accordion-collapse {
      transition: all 0.25s ease;
   }

   .accordion-title {
      font-weight: 700;
   }

   .accordion-sub-title {
      font-weight: 500;
   }

   .accordion-item:first-of-type {
      border-top-left-radius: 0;
      border-top-right-radius: 0;
   }

   .accordion-item:last-of-type {
      border-bottom-right-radius: 0;
      border-bottom-left-radius: 0;
      border-bottom: 0;
   }

   .accordion-button {
      font-size: 1.15rem;
      font-family: var(--font-industry);
      font-weight: 700;
      padding: 10px 0;
   }

   .top-separator {
      border-top: 1px solid var(--color-separator);
   }

   .accordion-button:focus:not(:focus-visible) {
      box-shadow: none;
   }

   .accordion-button::after {
      width: 30px;
      height: 30px;
      background-image: url(${ArrowBtn});
      transform: rotate(0deg);
      transition: transform 0.25s ease;
      visibility: ${props => (props.isEmpty ? 'hidden' : 'visible')};
   }

   .accordion-button:not(.collapsed)::after {
      transform: rotate(-180deg);
   }

   /* High-contrast mode styles */
   @media screen and (-ms-high-contrast: active) {
      .accordion-button {
         border: 2px solid currentColor;
      }
   }
`

export const FilterListAccordion = ({
   title,
   subTitle,
   icon,
   children,
   isOpen,
   isEmpty,
   className,
   noBorderSeparator
}) => {
   const uniqueId = generateUniqueId()

   return (
      <Container className={cx(className,"accordion-wrapper")}>
         <AccordionPanel isEmpty={isEmpty}>
            <div className="accordion-item">
               <h4
                  className="accordion-header"
                  id={`panelsStayOpen-headingOne-${uniqueId}`}
               >
                  <button
                     tabIndex="0"
                     className={cx(
                        'accordion-button',
                        isOpen ? 'show' : 'collapsed', 
                        !noBorderSeparator && 'top-separator' 
                     )}
                     type="button"
                     data-bs-toggle="collapse"
                     data-bs-target={`#panelsStayOpen-collapseOne-${uniqueId}`}
                     aria-expanded={isOpen}
                     aria-controls={`panelsStayOpen-collapseOne-${uniqueId}`}
                     disabled={isEmpty}
                  >
                     <div className="d-flex gap-2 align-items-center">
                        {icon}
                        <span
                           style={{
                              display: 'flex',
                              flexWrap: 'wrap',
                              columnGap: '0.25em',
                           }}
                        >
                           <span>{title}</span>
                           {subTitle && (
                              <span className="accordion-sub-title">
                                 {subTitle}
                              </span>
                           )}
                        </span>
                     </div>
                  </button>
               </h4>
               <div
                  id={`panelsStayOpen-collapseOne-${uniqueId}`}
                  className={`accordion-collapse ${
                     isOpen ? 'show' : 'collapse'
                  }`}
                  aria-labelledby={`panelsStayOpen-headingOne-${uniqueId}`}
               >
                  <div className="accordion-body">
                     <div className="mt-1">{children}</div>
                  </div>
               </div>
            </div>
         </AccordionPanel>
      </Container>
   )
}
